/**
  * api接口的统一出口
  */
import cclive from './cclive';
import comment from './comment';
import common from './common';
import play from './play';
// 其他模块的接口……

// 导出接口
export default {
  cclive,
  comment,
  common,
  play
}


// WEBPACK FOOTER //
// ./src/cmtapp/request/api/index.js